module.exports = __webpack_public_path__ + "static/media/paint_palette.8e05dc56.svg";